import regionReducer from "./regionReducer";

const regionReducers = {
    region: regionReducer
}

export default regionReducers;